module.exports = __webpack_public_path__ + "8dc74fa4f955f730461224a01cc337fe.svg";